module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"RvG","short_name":"RvG","icon":"static/img/icons/pwaicon.png","start_url":"/","lang":"de","display":"standalone","theme_color":"#fff","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d868e0e2f86a6668b7999505f5f4af83"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
